const packagesConfig = [
  {
    key: "complete",
    imageKey: "packages.complete.image",
    cmsSectionId: "package7day",
    htmlId: "package-7day",
    price: 2250,
    image:
      "https://images.unsplash.com/photo-1517411032315-54ef2cb783bb?auto=format&fit=crop&w=1200&q=80",
    gradient: "hero",
    theme: "premium",
    featured: true,
    order: 0,
  },
  {
    key: "adventure",
    imageKey: "packages.adventure.image",
    cmsSectionId: "package5day",
    htmlId: "package-5day",
    price: 1750,
    image:
      "https://images.unsplash.com/photo-1507272931001-fc06c17e4f43?auto=format&fit=crop&w=1200&q=80",
    gradient: "heroSolid",
    theme: "brand",
    order: 1,
  },
  {
    key: "threeDay",
    imageKey: "packages.threeDay.image",
    cmsSectionId: "package3day",
    htmlId: "package-3day",
    price: 1250,
    image:
      "https://images.unsplash.com/photo-1454496522488-7a8e488e8606?auto=format&fit=crop&w=1200&q=80",
    gradient: "hero",
    theme: "brand",
    order: 2,
  },
  {
    key: "taster",
    imageKey: "packages.taster.image",
    cmsSectionId: "package1day",
    htmlId: "package-1day",
    price: 380,
    image:
      "https://images.unsplash.com/photo-1705946985442-512875aaa310?auto=format&fit=crop&w=1200&q=80",
    gradient: "heroSolid",
    theme: "brand",
    order: 3,
  },
];

export const PACKAGE_KEYS = packagesConfig.map((pkg) => pkg.key);

export default packagesConfig;
